import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  logoWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // paddingTop: theme.spacing(0.875),
    // paddingBottom: theme.spacing(0.875),
    transition: 'all 0.5s ease-in-out',
    '.shrink &': {},
    [theme.breakpoints.up('lg')]: {
      // paddingRight: theme.spacing(8),
      '&.inner': {
        paddingRight: theme.spacing(0)
      }
    },
    '& a': {
      display: 'flex',
      flex: '0 0 100'
    }
  },
  logoImage: {
    width: 100,
    objectFit: 'contain',
    transition: 'all 0.5s ease-in-out',
    [theme.breakpoints.up('lg')]: {
      width: 140,
    }
    // '.shrink &': {
    //   width: 200
    // }
  },
  logoLink:{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    textDecoration: 'none',
    '& span':{
      transition: 'all 0.5s ease-in-out',
      color: theme.palette.colors.logoColor,
      marginLeft: theme.spacing(1),
      fontSize: theme.typography.pxToRem(26),
      fontWeight: theme.typography.fontWeightSemiBold,
      [theme.breakpoints.up('lg')]: {
        fontSize: theme.typography.pxToRem(32),
      },
      '.shrink &': {
        fontSize: theme.typography.pxToRem(26),
      }
    }
  }
}))
